/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import jQuery from 'jquery';

let Collapse = require('react-bootstrap').Collapse;

const $ = window.$ = window.jQuery = jQuery;

export default class extends Component {
    showLinks() {
        $(".estado").removeClass("selected");
        $("#nombre-estado").text(this.props.estado);

        $("path").removeClass("elegido");
        $("path#" + this.props.estado.replace(" ", "_")).addClass("elegido");
    }

    componentDidMount() {
        if (this.props.execute) {
            this.showLinks();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.execute) {
            this.showLinks();
        }
    }

    render() {
        return (
            <div>
                <h3>{this.props.estado}</h3>
                <Collapse in={this.props.execute}>
                    <ul className="estados-links">
                        <li><a className="link-rutas" href={`/#/estado/${this.props.estado}/rutas/_`}>Rutas</a></li>
                        <li><a className="link-rutas" href={`/#/estado/${this.props.estado}`}>Conocer</a></li>
                        <li><a className="link-rutas" href={`/#/estado/${this.props.estado}/pois`}>Navegar</a></li>
                    </ul>
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Estado.js